import LoginPassword         from "../../../domain/authentication/LoginPassword";
import Corporation           from "../../../domain/corporation/Corporation";
import CorporationName       from "../../../domain/corporation/CorporationName";
import CorporationNameKana   from "../../../domain/corporation/CorporationNameKana";
import CorporationRepository from "../../../domain/corporation/CorporationRepository";
import Building              from "../../../domain/fundamentals/address/Building";
import City                  from "../../../domain/fundamentals/address/City";
import PostalCode            from "../../../domain/fundamentals/address/PostalCode";
import Prefecture            from "../../../domain/fundamentals/address/Prefecture";
import Street                from "../../../domain/fundamentals/address/Street";
import Email                 from "../../../domain/fundamentals/email/Email";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Phone                 from "../../../domain/fundamentals/phone/Phone";
import { ApiClient }         from "../../configure/ApiClientConfig";
import {
  setCorporationAction,
  setCorporationAddressBuildingAction,
  setCorporationAddressCityAction,
  setCorporationAddressPostalCodeAction,
  setCorporationAddressPrefectureAction,
  setCorporationAddressStreetAction,
  setCorporationApplicantEmailAction,
  setCorporationApplicantFirstNameAction,
  setCorporationApplicantFirstNameKanaAction,
  setCorporationApplicantLastNameAction,
  setCorporationApplicantLastNameKanaAction,
  setCorporationNameAction,
  setCorporationNameKanaAction,
  setCorporationPhoneAction
}                            from "../../redux/corporation/CorporationAction";

class CorporationDataSource implements CorporationRepository {
  readonly dispatch;

  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  find() {
    return ApiClient.get("/corporation");
  }

  setCorporation(corporation: Corporation) {
    this.dispatch(setCorporationAction(corporation));
  }

  setCorporationAddressBuilding(building: Building) {
    this.dispatch(setCorporationAddressBuildingAction(building));
  }

  setCorporationAddressCity(city: City) {
    this.dispatch(setCorporationAddressCityAction(city));
  }

  setCorporationAddressPostalCode(postalCode: PostalCode) {
    this.dispatch(setCorporationAddressPostalCodeAction(postalCode));
  }

  setCorporationAddressPrefecture(prefecture: Prefecture) {
    this.dispatch(setCorporationAddressPrefectureAction(prefecture));
  }

  setCorporationAddressStreet(street: Street) {
    this.dispatch(setCorporationAddressStreetAction(street));
  }

  setCorporationApplicantEmail(email: Email) {
    this.dispatch(setCorporationApplicantEmailAction(email));
  }

  setCorporationApplicantFirstName(firstName: FirstName) {
    this.dispatch(setCorporationApplicantFirstNameAction(firstName));
  }

  setCorporationApplicantFirstNameKana(firstNameKana: FirstNameKana) {
    this.dispatch(setCorporationApplicantFirstNameKanaAction(firstNameKana));
  }

  setCorporationApplicantLastName(lastName: LastName) {
    this.dispatch(setCorporationApplicantLastNameAction(lastName));
  }

  setCorporationApplicantLastNameKana(lastNameKana: LastNameKana) {
    this.dispatch(setCorporationApplicantLastNameKanaAction(lastNameKana));
  }

  setCorporationName(name: CorporationName) {
    this.dispatch(setCorporationNameAction(name));
  }

  setCorporationNameKana(nameKana: CorporationNameKana) {
    this.dispatch(setCorporationNameKanaAction(nameKana));
  }

  setCorporationPhone(phone: Phone) {
    this.dispatch(setCorporationPhoneAction(phone));
  }

  update(corporation: Corporation) {
    return ApiClient.put("/corporation", {
      id: corporation.id.value,
      name: corporation.name.value,
      name_kana: corporation.nameKana.value,
      phone_number: corporation.phone.value,
      applicant: {
        last_name: corporation.applicant.name.lastName.value,
        first_name: corporation.applicant.name.firstName.value,
        last_name_kana: corporation.applicant.name.lastNameKana.value,
        first_name_kana: corporation.applicant.name.firstNameKana.value,
        email_address: corporation.applicant.email.value
      },
      address: {
        postal_code: corporation.address.postalCode.value,
        prefecture: corporation.address.prefecture.value,
        city: corporation.address.city.value,
        street: corporation.address.street.value,
        building: corporation.address.building.value
      }
    })
  }

  changePassword(currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword) {
    return ApiClient.put("/corporation/password", {
      currentPassword: currentPassword.value,
      newPassword: newPassword.value,
      confirmPassword: confirmPassword.value,
    });
  }

}

export default CorporationDataSource;
